/*jshint esversion: 6 */
/*! webmd.core */

export let substitute;
export let htmlEncode;
export let reEncode;
export let openWindow;
export let object;
export let getResponsiveWidthType;
export let customEvent;
export let getPvid;
export let createPvid;
export let getAvid;
export let createAvid;

if (typeof window !== 'undefined') {

    // Check that image_server_url is defined, if not, set it to live
    // define blank strings that are not defined earlier or will not be defined later
    // used to prevent the sl() function from crashing
    window.image_server_url = window.image_server_url || location.protocol + '//img.webmd.com/dtmcms/live';
    window.s_business_reference = window.s_business_reference || '';
    window.s_furl = window.s_furl || '';
    window.s_package_type = window.s_package_type || '';
    window.s_package_name = window.s_package_name || '';
    window.s_sponsor_program = window.s_sponsor_program || '';
    window.s_pageview_id = window.s_pageview_id || '';
    window.s_avid = window.s_avid || '';

    createPvid = function() {
        /**
         * creating a local scope for any local variables,
         * but otherwise just executing. Not bothering with a module or anything else more complicated
         * Get the seconds since epoch and convert to a string max 10 digits.
         */
        const timestamp = Math.floor(new Date().getTime() / 1000).toString().substring(0, 10);

        /**
         * Making an 8 digit random number
         * Sometimes random() returns somethign with less digits like .5
         * In that case we use toFixed() to convert to a string and pad with zeroes
         * Then we lop of the "0." at the front of the string and take the next eight digits
         */
        const randomNumber = Math.random().toFixed(8).substring(2, 10);
        
        /**
         * PVID includes both timestamp and randomNumber
         */
        const pvid = timestamp + randomNumber;

        // Set s_pageview_id globaly
        window.s_pageview_id = pvid;
        return pvid;
    };

    // creating alloy visitor id which will be called only once per article
    createAvid = function () {
        const timestamp = Math.floor(new Date().getTime() / 1000).toString().substring(0, 10);
        const randomNumber = Math.random().toFixed(8).substring(2, 10);
        const avid = timestamp + randomNumber;
        window.s_avid = avid;
        return avid;
    };
    
    getPvid = function () {
        if (window.s_pageview_id === '') {
            createPvid();
        }
        return window.s_pageview_id;
    };

    getAvid = function (reinit) {
        if (window.s_avid === '' || reinit) {
            createAvid();
        }
        return window.s_avid;
    };
   

    /**
     * Substitute object values into a string.
     *
     * @param {String} template Template string with object keys surrounded by {}
     * @param {Object} o Key:value pairs to substitute in the string.
     * @param {Boolean} [removeUnmatchedKeys=false] Set this true if you want to remove {key} from the template if it is not found in the object.
     * 
     * @example
     * s = substitute("Hello {first} {last}!", {first:'Joe', last:'Smith'});
     */
    substitute = function (s, o, removeUnmatchedKeys) {

        return s.replace(/\{([^{}]*)\}/g, function (a, b) {
            let val, r = object.get(b, o);

            // If the object has a member that matches the template marker,
            // and the member is a string or a number, then insert it in the template.
            if (typeof r === 'string' || typeof r === 'number') {
                val = r;

                // If removeUnmatchedKeys is on, insert ""
            } else if (removeUnmatchedKeys) {
                val = '';

                // leave the template marker alone.
            } else {
                val = a;
            }
            return val;
        });
    };
    /**
     * Encode a string so it is safe to display as text.
     *
     * If you are immediately adding the text to the page, use jQuery's text() method instead of this.
     *
     * @returns {String} Encoded text
     *
     * @param {String} text Text to encode
     *
     * @example
     * s = webmd.htmlEncode('&lt;p&gt;Hello!');
     * // s === '&amp;lt;p&amp;gt;Hello!'
     */
    htmlEncode = function (s) {
        return s.replace(/\&/g, "&amp;").replace(/</g, "&lt;").replace(/\>/g, "&gt;").replace(/\"/g, '&quot;');
    };

    /**
     * Encode a string so it is safe to use within a regular expression.
     *
     * <p>In some cases you need to put unknown text within a regular expression (RE).
     * This might cause the RE to break if the text contains any
     * of the special RE characters such as .*()/
     * </p>
     *
     * This function encodes those special characters so you can use them safely within the RE.
     *
     * @returns {String} Encoded text
     *
     * @param {String} text Text to encode
     *
     * @example
     * re = new RegExp('^Name: ' + webmd.reEncode(value));
     */
    reEncode = function (s) {
        return s.replace(/([.*+?|(){}\[\]\\])/g, '\\$1');
    };

    /**
     * Open a new browser window with various options, and give focus to the window.
     *
     * @returns {Window|null} The Window object that was opened, or null if the window was not opened successfully.
     *
     * @param {String} url URL to open
     * @param {Object} [options] Options for opening the window
     * @param {Boolean} [options.focus=true] After creating the window, give window focus to ensure it pops to top.
     * @param {String} [options.name=""] Give the window a name
     * @param {Boolean} [options.standard=false] If you set this to true, then we will start with a "standard" list of window options.
     * <p>The standard options are as follows:</p>
     * <ul>
     * <li>location:1</li>
     * <li>menubar:1</li>
     * <li>resizable:1</li>
     * <li>scrollbars:1</li>
     * <li>status:1</li>
     * <li>toolbar:1</li>
     * </ul>
     * @param {Boolean} [options.xxx] You can specify other window options as part of the options, such as width, height, etc.
     * <p>For a list of window features refer to:
     * <a href="https://developer.mozilla.org/En/DOM:window.open">https://developer.mozilla.org/En/DOM:window.open</a></p>
     * <p>If you define window features, then the features that are not listed might be disabled or removed
     * (depending on the way various browsers implement these window options).</p>
     */
    openWindow = function (url, options) {

        let defaults, f, featuresArray, skip, w;

        if (!options) { options = {}; }

        // Set the default options.
        defaults = { name: '', focus: true };

        // If 'standard' options were requested, add the standard window attributes.
        if (options.standard) {
            defaults = Object.assign(defaults, {
                location: 1, // cannot turn this off in modern browsers
                menubar: 1,
                resizable: 1, // cannot turn this off in modern browsers
                scrollbars: 1, // should not turn this off for accessbility reasons
                status: 1, // cannot turn this off in some browsers
                toolbar: 1
            });
        }

        // Let the user override the defaults
        options = Object.assign(defaults, options);

        // Options that are not window features and will be stripped out
        skip = { name: 1, focus: 1, standard: 1 };

        // Create the windows feature string.
        featuresArray = [];
        for (f in options) {

            // Prevent looping through object prototype chain
            if (options.hasOwnProperty(f)) {

                // Skip the options that are not window features
                if (skip[f]) { continue; }

                featuresArray.push(f + '=' + options[f]);
            }
        }

        // Open the window
        w = window.open(url, options.name, featuresArray.join(','));
        if (options.focus && w) {
            w.focus();
        }
        return w;
    };

    /**
     * Create a new object using prototypal inheritance from another object
     *
     * <p>This is our standard development pattern for object oriented javascript.
     * Refer to the following wiki page for example usage:
     * <a href="http://webservices.webmd.net/wswiki/Javascript-object-oriented-development-pattern.ashx">
     * http://webservices.webmd.net/wswiki/Javascript-object-oriented-development-pattern.ashx</a></p>
     *
     * @namespace Create a new object using prototypal inheritance from another object, plus additional
     * functions for getting and setting parameters of deep objects.
     * @function
     *
     * @returns {Object} The new object
     *
     * @param {Object} obj The object you want to copy and inherit from
     * @param {Object} [props] List of properties to extend the object.
     * This can be used to change the values of existing object properties (such as default options),
     * to override methods of the object, or to extend the object with new properties or methods.
     *
     * @example
     * var o = webmd.object(srcObject);
     *
     * @example
     * // Override one of the parameters
     * var o = webmd.object(srcObject, {delay:500});
     *
     * @example
     * // Extend the object with a new method
     * var o = webmd.object(srcObject, {alert:function(){ alert('Hello!'); }});
     *
     */
    object = (function () {
        // boodman/crockford delegation w/ cornford optimization
        function TMP() { }
        return function (obj, props) {
            TMP.prototype = obj;
            var tmp = new TMP();
            if (props) {
                Object.assign(tmp, props);
            }
            return tmp; // Object
        };
    })();

    /**
     *  Will return a certain number based on the current width of the page. Used for responsive design.
     *  @return   int   the id of the certain range of widths 
     */
    getResponsiveWidthType = function () {
        let width = window.innerWidth ? parseInt(window.innerWidth) : parseInt(document.getElementsByTagName('body')[0].parentNode.offsetWidth);

        if (width < 640) {
            return 5;
        } else if (width > 639 && width < 768) {
            return 4;
        } else if (width > 767 && width < 1024) {
            return 3;
        } else if (width > 1023 && width < 1240) {
            return 2;
        } else if (width > 1239) {
            return 1;
        }
    };

    customEvent = function () {
        // polyfill for CustomEvent() functionality in IE 11
        (function () {

            if (typeof window.CustomEvent === "function") return false;

            function CustomEvent(event, params) {
                let evt = document.createEvent('CustomEvent');

                params = params || { bubbles: false, cancelable: false, detail: null };
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;

            window.CustomEvent = CustomEvent;
        })();
    };

    // Add more functions onto webmd.object()
    Object.assign(object, /** @lends webmd.object */ {

        /*! BEGIN LICENSE getObject
         * jQuery getObject
         * http://benalman.com/projects/jquery-getobject-plugin/
         * Copyright (c) 2009 "Cowboy" Ben Alman
         * Dual licensed under the MIT and GPL licenses.
         * http://benalman.com/about/license/
         * Inspired by Dojo, which is Copyright (c) 2005-2009, The Dojo Foundation.
         */

        /**
         * Get a property of an object via dot-delimited name string, and optionally
         * create the property and any ancestor properties that do not already exist.
         *
         * @param {String} name Dot-delimited string representing a property name, for
         * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
         * @param {Boolean} [create=false] Create final and intermediate properties if they don't
         * exist.
         * @param {Object} [context=window] Optional context in which to evaluate name.
         * @returns {Object} An object reference or value on success, otherwise undefined.
         *
         * @example
         * var o = webmd.object.get('webmd.m.myObject.data.part');
         * if (o) { do_something(); }
         *
         * @example
         * var o = webmd.object.get('webmd.m.myObject.data.part', true);
         * // o is guaranteed to exist because we specified the "create" option
         *
         * @example
         * // Search within the context of a known object
         * var o = webmd.object.get('myObject.data.part', webmd.m);
         *
         */
        get: function (parts, create, obj) {
            let origParts = parts, p;

            if (typeof parts === 'string') {
                parts = parts.split('.');
            }

            if (typeof create !== 'boolean') {
                obj = create;
                create = undefined;
            }

            obj = obj || window;

            //first, check if the value exists as a string i.e. obj['a.b']
            if (obj[origParts] !== undefined) {
                obj = obj[origParts];
            } else {
                //otherwise, iterate through the split parts

                while (obj && parts.length) {
                    p = parts.shift();
                    if (obj[p] === undefined && create) {
                        obj[p] = {};
                    }
                    obj = obj[p];
                }
            }

            return obj;
        },


        /**
         * Set a property of an object via dot-delimited name string, creating any
         * ancestor properties that do not already exist.
         *
         * @param {String} name Dot-delimited string representing a property name, for
         * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
         * @param {expression} value Any valid JavaScript expression.
         * @param {Object} [context=window] Optional context in which to evaluate name.
         *
         * @returns {expression} The value if set successfully, otherwise undefined.
         */
        set: function (name, value, context) {

            let parts = name.split('.'),
                prop = parts.pop(),
                obj = this.get(parts, true, context);

            // Only return the value if it is set successfully.
            return (obj && typeof obj === 'object' && prop) ? (obj[prop] = value) : undefined;
        },


        /**
         * Using dot-delimited name string, return whether a property of an object
         * exists.
         *
         * @param {String} name Dot-delimited string representing a property name, for
         * example: 'document', 'location.href', 'window.open' or 'foo.bar.baz'.
         * @param {Object} [context=window] Optional context in which to evaluate name.
         *
         * @returns {Boolean} Whether or not the property exists.
         */
        exists: function (name, context) {
            return this.get(name, context) !== undefined;
        }

        /*! END LICENCE getObject */

    }); // extend webmd.object

    // Prevent document.write from running after document load
    // (and breaking the page)
    document.addEventListener('DOMContentLoaded', function () {
        window.document.write = function (s) {
            throw ('INVALID document.write: ' + s);
        };
    });

    // Expose some functions to global window
    window.createPvid = createPvid;
}